// extracted by mini-css-extract-plugin
export default {"root":"FutureWeather_root__wSwfN","date":"FutureWeather_date__nVyiR","temp":"FutureWeather_temp__c2SXK","icon":"FutureWeather_icon__7vSAr"};